<div id="grievances-icc" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Grievances Redressal & ICC</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College is committed to providing a safe, inclusive, and harmonious environment for all students, staff, and stakeholders. The Grievance Redressal Cell and the Internal Complaints Committee (ICC) ensure that all grievances are addressed promptly, fairly, and confidentially.
    </p>

    <hr class="divider">

    <div class="row g-4 mt-2">
      <div class="col-md-6">
        <div class="info-card">
          <h5><i class="fa fa-gavel text-primary me-2"></i>Objectives</h5>
          <p>To provide a formal mechanism for addressing complaints related to academic matters, harassment, discrimination, and other institutional issues — ensuring transparency, fairness, and swift resolution.</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="info-card">
          <h5><i class="fa fa-list-alt text-warning me-2"></i>Functions</h5>
          <p>The cell receives and investigates grievances, conducts hearings, recommends appropriate actions, and ensures compliance with institutional policies and statutory guidelines.</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="info-card">
          <h5><i class="fa fa-user text-success me-2"></i>Ombudsperson</h5>
          <p>An independent Ombudsperson is appointed to oversee grievance redressal, ensuring impartial adjudication and maintaining the highest standards of fairness in the grievance process.</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="info-card">
          <h5><i class="fa fa-shield text-danger me-2"></i>Internal Complaint Committee (ICC)</h5>
          <p>The ICC is constituted as per POSH Act 2013 guidelines to address complaints of sexual harassment. The committee ensures a safe workplace for all members of the institution.</p>
        </div>
      </div>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Key Documents</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="/assets/pdf/grievances/Objectives-of-the-Student-Grievance-Committee.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Objectives
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/grievances/Functions.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Functions
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/grievances/Committee-6.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Committee
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/grievances/Grievance-Redressal.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Grievance Redressal
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/grievances/Grievance-policy.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>Grievance Policy
        </a>
      </div>
      <div class="col-md-4">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSeCSNcOSeDD8xJ1PcnIpQEfjQ0-p9KyKmFJeGfXpDW5XK8gGA/viewform" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-edit me-2"></i>Submit a Grievance
        </a>
      </div>
    </div>

  </div>
</div>
